import { ref } from 'vue'

// Fase 4.1 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
// registerServiceWorker.ts seta isso no hook `updated()`, quando o Workbox
// detecta que um novo Service Worker assumiu o controle da aba (skipWaiting +
// clientsClaim, ver vue.config.js) — ou seja, o bundle JS já carregado em
// memória ficou desatualizado de verdade em relação ao que está publicado.
// Login usa isso pra só limpar o cache do SW quando existe uma versão nova de
// fato, em vez de fazer isso incondicionalmente em todo login.
export const appUpdateAvailable = ref(false)

export function markAppUpdateAvailable(): void {
  appUpdateAvailable.value = true
}
